module.exports = __webpack_public_path__ + "img/5.a5f5f5f0.png";